var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"rounded bg-ontick-blue-900 px-3 py-1 text-center text-ontick-blue-50"},[_vm._v(" "+_vm._s(_vm.type === "PORTFOLIO" ? "Portfólio" : "Estratégia")+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }